import { Reports } from '@yuno/types'
import { useEffect, useState } from 'react'
import type { UseQueryResult } from 'react-query'
import {
  useGetReportsList,
  useGetDownloadReport,
  useCancelReport,
} from '@yuno/dashboard-api-mfe'
import { useLogout } from '../../../account-menu/hooks'
import { useSnackbarContext } from '../../../../yuno-dashboard-container-mfe'
import { DialogTexts } from '../../../../utils/constants'

export const useReports = ({ saved }) => {
  const { onOpenSnackbar } = useSnackbarContext()
  const [newReports, setNewReports] = useState(0)
  const [open, setOpen] = useState(false)
  const [openReports, setOpenReports] = useState(false)
  const [reports, setReports] = useState()
  const [error, setError] = useState(false)
  const [reportId, setReportId] = useState(null)
  const [reportFiltered, setReportFiltered] = useState(null)
  const [reportDownloaded, setReportDownloaded] = useState(null)
  const [intervalTimer] = useState(null)
  const { isNotAuth } = useLogout()
  const response: UseQueryResult<Reports.IListReportsQueryParams> =
    useGetReportsList()

  const onSuccess = (data) => {
    if (data.redirect_link) {
      const link = document.createElement('a')
      link.href = data.redirect_link
      link.target = '_blank'
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
    } else {
      onOpenSnackbar(DialogTexts.GENERATE_REPORT_AGAIN, 'error', 'Info')
    }
    setReportId(null)
  }

  const downloadReport: UseQueryResult<string> = useGetDownloadReport(
    reportId,
    false,
    onSuccess,
  )

  const mutation: UseQueryResult<string> = useCancelReport()

  const handleReportsResponse = () => {
    const date = localStorage.getItem('lastOpen')
    if (reportFiltered) {
      const responseFiltered = reportFiltered.filter((element) => {
        const el = new Date(element.updated_at)
        return el.getTime() > Number(date)
      })

      const reportsDownloaded = responseFiltered.filter(
        (report) => report.status == 'DOWNLOADED',
      ).length
      const reportsSucceded = responseFiltered.filter(
        (report) => report.status == 'SUCCEEDED',
      ).length
      const reportsFailed = responseFiltered.filter(
        (report) => report.status == 'FAILED' || report.status == 'ERROR',
      ).length
      setNewReports(reportsFailed + reportsSucceded - reportsDownloaded)
    }
  }

  const refetchResponse = () => {
    const isOnline = navigator.onLine
    isOnline && response.refetch()
  }

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setOpenReports(false)
    setReportId(null)
  }

  const handleDownload = (element, reportId) => {
    setReportId(reportId)
  }

  const handleClickInput = () => {
    setOpenReports(true)
    setOpen(false)
  }

  const handleClickInputReturn = () => {
    setOpenReports(false)
    setOpen(true)
  }

  const handleClickCancel = (e) => {
    const reportId = e.target.value
    mutation.mutate(reportId)
  }

  useEffect(() => {
    if (mutation.isSuccess && !response?.data?.code) {
      refetchResponse()
    }
  }, [mutation, response])

  useEffect(() => {
    isNotAuth(response?.data)
    if (response && response.data && !response?.data?.code) {
      setReports(response.data)
      setReportFiltered(response.data)
      handleReportsResponse()
    } else if (response?.data?.code) {
      clearInterval(intervalTimer)
      setError(true)
    }
  }, [response])

  useEffect(() => {
    isNotAuth(downloadReport)
    if (
      downloadReport.data &&
      downloadReport.data !== reportDownloaded &&
      !downloadReport?.data?.code
    ) {
      setReportDownloaded(downloadReport.data)
    }
  }, [downloadReport])

  useEffect(() => {
    handleReportsResponse()
  }, [saved])

  useEffect(() => {
    if (reportId) {
      downloadReport.refetch()
    }
  }, [reportId])

  return {
    newReports,
    reports,
    reportDownloaded,
    open,
    handleClick,
    handleClose,
    handleDownload,
    handleClickInput,
    handleClickInputReturn,
    openReports,
    refetchResponse,
    handleClickCancel,
    error,
  }
}
